import { TravelerTranslationModel } from '../models/translation.model';
import { Language } from '@tbums.mono.web/tbums-lib';

export const translationEN: TravelerTranslationModel = {
  language: Language.EN,
  searchPlaceholder: 'Search stop',
  today: 'Today',
  tomorrow: 'Tomorrow',
  list: {
    noStopsTitle: 'No stops found',
    noStopsHint: 'Check the spelling or search for another place.',
    distanceInfo: 'Distance is calculated from your position',
  },
  panel: {
    collapse: 'Collapse',
    expand: 'Expand',
  },
  stop: {
    route: 'Route',
    replacedTrain: 'Replaced train',
    towards: 'Towards',
    departs: 'Time',
    stop: 'Stop',
    location: 'Location',
    active: 'Active',
    reason: 'Reason',
    vehicleIdentifier: 'Vehicle',
    disembarkingOnly: 'Disembark only',
  },
  info: {
    about: 'About',
    content:
      "This website displays information about replacement services operated by Nobina on behalf of your train company. The goal is for you as a traveler to receive relevant information about ongoing replacement traffic, regardless of whether it is planned or urgent. The page shows all confirmed traffic for the next 24 hours. All the information you can find on this page is also fully available via API for integration into travel apps, travel planners and other services. We are Nobina, the largest public transport company in the Nordics. With us, 13,000 people work every day to find solutions to your everyday puzzle and to society's major challenges.",
    readMore: 'Read more at nobina.com',
    close: 'Close',
  },
  error: {
    affectedStopsMissing: 'There is no traffic at the moment',
    stopMissing: 'No information available for this stop',
    tripMissing: 'No information available for this trip',
    close: 'Close',
  },
  seo: {
    tagline: 'Where is my bus?',
    description:
      'Replacement traffic operated by Nobina on behalf of your train company. The goal is to provide you as a passenger with relevant information about ongoing replacement traffic.',
  },
  customerDisplay: {
    route: 'Route',
    destination: 'Destination',
    departures: 'Departures',
  },
};
